<template>
  <div>
    <vcl-facebook secondary="#ff9f43" v-if="loading"></vcl-facebook>
    <div v-if="!loading">
      <div style="cursor: pointer; width:100px;" class="px-4 py-1 flex items-center">
        <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
        <JsonExcel :data="listForExcel" class>İndir</JsonExcel>
      </div>
      <vs-table
        max-items="50"
        stripe
        search
        pagination
        :data="list"
        class="subscriptions"
        maxHeight="400px"
        noDataText="Kayıt bulunamadı"
      >
        <template slot="thead">
          <vs-th>#</vs-th>
          <vs-th>Bitiş tarihi</vs-th>
          <vs-th>Durum</vs-th>
          <vs-th>Abonelik</vs-th>
          <vs-th>Müşteri</vs-th>
          <vs-th>İşlemler</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :state="tr.subscriptionStatus.classList" :key="i" v-for="(tr, i) in data">
            <vs-td :data="tr.id">{{tr.id}}</vs-td>
            <vs-td :data="tr.endDate">{{tr.endDate.toString().substr(0,10)}}</vs-td>
            <vs-td :data="tr.subscriptionStatus">{{tr.subscriptionStatus.value}}</vs-td>
            <vs-td :data="tr.unit">
              <span>{{tr.unit.value.substr(0,50)}}</span>
              <span class="hidden">{{tr.unit.value}}</span>
            </vs-td>
            <vs-td :data="tr.customer">
              <span :title="tr.customer.value">{{tr.customer.value.substr(0,50)}}</span>
              <span class="hidden">{{tr.customer.value + tr.customer.phone}}</span>
            </vs-td>
            <vs-td></vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { repository } from "@/_services/repository.js";
import { VclFacebook } from "vue-content-loading";
import JsonExcel from "vue-json-excel";
export default {
  components: {
    VuePerfectScrollbar,
    VclFacebook,
    JsonExcel
  },
  data() {
    return {
      loading: true,
      list:[],
      listForExcel:[],
    };
  },
  computed: {
    trColor(state) {
      switch (state) {
        case 0:
          return null;
        case 1:
      }
      state == 2 || state == 5 ? "success" : state == 6 ? "danger" : null;
    }
  },
  methods: {
    getList: async function() {
      let x = await repository.getAll("subscription/getsubscriptions");
      if (x && x.isSuccessful) {
        x = x.list;
        x = repository.convertToJSON(x, "customer");
        x = repository.convertToJSON(x, "subscriptionStatus");
        x = repository.convertToJSON(x, "unit");
        for (let i = 0; i < x.length; i++) {
          x[i].customer = x[i].customer[0];
          x[i].subscriptionStatus = x[i].subscriptionStatus[0];
          x[i].unit = x[i].unit[0];
          let a=Object.assign({},x[i]);
          a.customer=a.customer.value;
          a.subscriptionStatus=a.subscriptionStatus.value;
          a.unit=a.unit.value;
          this.listForExcel.push(a);
        }
        this.list = x;
        this.loading = false;
        return;
      }
      this.$vs.notify({
        title: "Hata",
        text: "Bağlantı hatası",
        color: "danger"
      });
    }
  },
  beforeMount() {
    this.getList();
  }
};
</script>

<style type="text/css" scoped>
.subscriptions td {
  padding: 4px 10px 4px 10px !important;
}
</style>